export default "__VITE_ASSET__Dqg1AOBJ__"